"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const contributionsDataUpdated = graphql_tag_1.default `
  subscription($environmentId: String!, $type: String!) {
    contributionsDataUpdated(environmentId: $environmentId, type: $type) {
      id
      type
      agentId
      contribution
      data
    }
  }
`;
exports.default = contributionsDataUpdated;
//# sourceMappingURL=contributionsDataUpdated.js.map